export const drawerHeaderHeight = 60;

export const minReviewsToDisplay = 2;

export const infiniteScrollTrigger = 800;

export const initialPageReviewCount = 4;

export const noResultRefScrollHeight = 620;

export const perPage = 20;
